export type HourFormatType = 'h' | 'hh';

export const getFormattedTime = (originalTime: string, hourFormat?: HourFormatType) => {
  // checks validation of hour in form like `13:15`
  const timeRegex = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
  if (!timeRegex.test(originalTime)) {
    console.error(`Invalid time format: ${originalTime}.`);
    return null;
  }

  const timeParts = originalTime.split(':');

  const date = new Date();
  date.setHours(+timeParts[0], +timeParts[1]);
  // format dateString always to US format for consistency, independently of locale
  return date.toLocaleString('en-US', {
    hour12: true,
    hour: hourFormat === 'hh' ? '2-digit' : 'numeric',
    minute: '2-digit',
  });
};
